import { Navigate, useLocation, useParams } from 'react-router';

import { paths } from '@/app/router/paths';

/**
 * Een link van vóór het adres in de link: `/rapport/{ordernummer}/{token}`.
 *
 * Meestal stuurt de server zo'n link al door. Kwam hij toch hier (een link die
 * niet meer opent, of een pagina uit de service worker van kantoor), dan gaat hij
 * vóór er iets geladen is naar `/r/{token}`, met zijn `?lang=` en zijn `#kosten`.
 * De klantpagina zet daarna het adres erachter. Het ordernummer wordt niet gelezen.
 */
export function LegacyPublicReportRedirect() {
    const { token = '' } = useParams<{ orderNumber: string; token: string }>();
    const { search, hash } = useLocation();

    return <Navigate to={{ pathname: paths.publicReport(token), search, hash }} replace />;
}
